import { create } from "zustand";
import {
  LOTInfoDto,
  PDA1080R01GridData,
} from "./PDA1080_R01Dto";

/**
 * PDA1080_R01 자재반입 Store
 * 
 * - LOT 스캔으로 자재 정보 조회
 * - 반입 수량 입력 후 그리드에 추가
 * - 여러 LOT를 일괄 반입 가능
 */
export interface PDA1080_R01Store {
  // LOT 스캔 상태
  lotNo: string;                      // LOT 번호 입력
  scannedLot: LOTInfoDto | null;      // 스캔된 LOT 정보
  returnQty: number;                  // 반입 수량 입력
  
  // 반입 대기 목록 (그리드)
  returnItems: PDA1080R01GridData[];  // 반입 대기 중인 항목들
  
  // 로딩 상태
  loading: boolean;
  
  // Actions
  setLotNo: (lotNo: string) => void;
  setScannedLot: (lot: LOTInfoDto | null) => void;
  setReturnQty: (qty: number) => void;
  setLoading: (loading: boolean) => void;
  
  // 반입 목록 Actions
  addReturnItem: (item: PDA1080R01GridData) => void;
  removeReturnItem: (lotNo: string, itemCd: string) => void;
  clearReturnItems: () => void;
  
  // 초기화
  reset: () => void;
}

const usePDA1080_R01Store = create<PDA1080_R01Store>((set) => ({
  // 초기값
  lotNo: "",
  scannedLot: null,
  returnQty: 0,
  returnItems: [],
  loading: false,

  // Actions
  setLotNo: (lotNo) => set({ lotNo }),
  setScannedLot: (lot) => set({ scannedLot: lot }),
  setReturnQty: (qty) => set({ returnQty: qty }),
  setLoading: (loading) => set({ loading }),
  
  // 반입 목록 Actions
  addReturnItem: (item) =>
    set((state) => ({
      returnItems: [...state.returnItems, item],
    })),
  
  removeReturnItem: (lotNo, itemCd) =>
    set((state) => ({
      returnItems: state.returnItems.filter(
        (item) => !(item.lotNo === lotNo && item.itemCd === itemCd)
      ),
    })),
  
  clearReturnItems: () => set({ returnItems: [] }),
  
  // 초기화
  reset: () =>
    set({
      lotNo: "",
      scannedLot: null,
      returnQty: 0,
      returnItems: [],
      loading: false,
    }),
}));

export default usePDA1080_R01Store;
